import React from 'react';

import Badge from '../../badge';
import ButtonV2 from '../../button/button_v2';
import IconStatusSucesso from '../../../assets/icons/icon-status-enviado.svg';
import { BodyM, BodyMSpan, BodyP, BodyPSpan, H5 } from '../../../styles/stylesTypography';
import { theme } from '../../../styles/theme';
import { formatDateBR, isDataValida } from '../../../services/bloqueioAcesso';

const BENEFICIOS = [
    'Emissão de receituário agronômico em todos os estados onde você atua',
    'Seus produtores, fazendas, ARTs e receitas anteriores intactos',
    'Envio automático ao órgão de defesa e ao produtor',
];

/**
 * Conteúdo da modal de reativação: conta com pagamento confirmado cuja
 * assinatura está inativa. Ex-cliente não pode mais usar cupom de primeira
 * compra, então aqui não há desconto — a oferta é reativar.
 *
 * Só o conteúdo: quem abre decide o container da modal.
 *
 * @param {object} props
 * @param {string|null} [props.inativoDesde] Data ISO do bloqueio. Ausente ou futura, o texto sai sem data.
 * @param {() => void} props.onReativar Ação do botão principal.
 * @param {() => void} props.onFalarConsultor Ação do botão secundário.
 */
const ModalReativacao = ({ inativoDesde, onReativar, onFalarConsultor }) => {
    const dataInativoFormatada = isDataValida(inativoDesde) ? formatDateBR(inativoDesde) : '';

    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
            }}
        >
            <Badge colorBg={theme.colors.red.fundo} colorText={theme.colors.red.Vermelho_erro}>
                ASSINATURA INATIVA
            </Badge>

            <H5>Reative sua assinatura para voltar a emitir</H5>

            <BodyM>
                {dataInativoFormatada ? (
                    <>Sua assinatura do AgroReceita está inativa desde <br/><BodyMSpan fontWeight={800}>{dataInativoFormatada}</BodyMSpan>. Seus dados continuam salvos e voltam a ficar disponíveis assim que a assinatura for reativada.</>
                ) : (
                    <>Sua assinatura do AgroReceita está inativa. Seus dados continuam salvos e voltam a ficar disponíveis assim que a assinatura for reativada.</>
                )}
            </BodyM>

            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    background: theme.colors.gray.Cinza_13,
                    borderRadius: '12px',
                    padding: '16px',
                    textAlign: 'left',
                    boxSizing: 'border-box',
                }}
            >
                {BENEFICIOS.map((item) => (
                    <div
                        key={item}
                        style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '8px',
                        }}
                    >
                        <img src={IconStatusSucesso} alt="" style={{ width: '18px', height: '18px', marginTop: '2px', flexShrink: 0 }} />
                        <BodyM color={theme.colors.gray.Cinza_2}>{item}</BodyM>
                    </div>
                ))}
            </div>

            <div
                className="button-finish"
                style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px',
                }}
            >
                <ButtonV2
                    width='100%'
                    height='50px'
                    value='REATIVAR ASSINATURA'
                    outline={false}
                    disabled={false}
                    onClick={onReativar}
                    loading={false}
                />
                <ButtonV2
                    width='100%'
                    height='50px'
                    value='FALAR COM UM CONSULTOR'
                    outline={true}
                    color={theme.colors.gray.Cinza_2}
                    disabled={false}
                    onClick={onFalarConsultor}
                    loading={false}
                />
            </div>

            <BodyP color={theme.colors.gray.Cinza_7}>
                Dúvidas sobre planos e valores? <BodyPSpan color={theme.colors.blue.Azul_link} cursor="pointer" onClick={onReativar}>Ver planos disponíveis</BodyPSpan>
            </BodyP>
        </div>
    );
};

export default ModalReativacao;
